/*
const QA_CONFIG = {
  ENV: "QA",
  BASE_URL: "https://nexusqa.honeywell.com",
  SSO_BASE_URL: "https://qauthn.honeywell.com/",
  AUTH_URL: "as/authorization.oauth2?",
  TOKEN_URL: "as/token.oauth2",
  INFO_URL: "idp/userinfo.openid",
  APP_ID: "163",
  CLIENT_ID: "Client_163",
  CLIENT_SECRET: "#z)5pn&wb11bvc0a", // "NEXUSQA@2022",
  SSO_AUTHORITY: "https://qauthn.honeywell.com/as/authorization.oauth2",
  SSO_TOKENENDPOINT: "https://qauthn.honeywell.com/as/token.oauth2",
  SESS_KEY: "NexusSeSS2DotO__zz",
  SSO_RESPONSE_TYPE: "code",
  SSO_SCOPE: "openid+email+profile",
  SSO_REDIRECT_URL: "",
  SSO_LOGOUT_URL: "idp/startSLO.ping?appid=",
  SESS_REDITECT_URI: "RedirectUri",
  API_ENDPOINT: "https://nexus-qa-app-api.azurewebsites.net/",
  DEV_MODENEXUS: false,
};

const PROD_CONFIG = {
  ENV: "production",
  BASE_URL: "https://nexus.honeywell.com",
  SSO_BASE_URL: "https://authn.honeywell.com/",
  AUTH_URL: "as/authorization.oauth2?",
  TOKEN_URL: "as/token.oauth2",
  INFO_URL: "idp/userinfo.openid",
  APP_ID: "293",
  CLIENT_ID: "Client_293",
  CLIENT_SECRET: "NEXUS@2022",
  SSO_RESPONSE_TYPE: "code",
  SSO_SCOPE: "openid+email+profile",
  SESS_KEY: "NexusSESS2DOTO__zz",
  SSO_REDIRECT_URL: "",
  SSO_LOGOUT_URL: "idp/startSLO.ping?appid=",
  SESS_REDITECT_URI: "RedirectUri",
  API_ENDPOINT: "https://nexus.honeywell.com/",
  SSO_AUTHORITY: "https://qauthn.honeywell.com/as/authorization.oauth2",
  SSO_TOKENENDPOINT: "https://qauthn.honeywell.com/as/token.oauth2",
  DEV_MODENEXUS: false,
};

const DEV_CONFIG = {
  ENV: "development",
  BASE_URL: "https://nexusdev.honeywell.com",
  SSO_BASE_URL: "https://qauthn.honeywell.com/",
  AUTH_URL: "as/authorization.oauth2?",
  TOKEN_URL: "as/token.oauth2",
  INFO_URL: "idp/userinfo.openid",
  APP_ID: "164",
  CLIENT_ID: "Client_164",
  CLIENT_SECRET: "lj$cb1-h$m8d5yhs", //"a9st3!nmv-.dnmr8",//"NEXUSDEV@2022",
  SSO_RESPONSE_TYPE: "code",
  SESS_KEY: "NexusSeSS2DotO__zz",
  SSO_SCOPE: "openid+email+profile",
  SSO_REDIRECT_URL: "",
  SSO_LOGOUT_URL: "idp/startSLO.ping?appid=",
  SESS_REDITECT_URI: "RedirectUri",
  // API_ENDPOINT: "https://nexusdev.honeywell.com/",
  API_ENDPOINT: "https://nexus-dev-app-api.azurewebsites.net/",
  SSO_AUTHORITY: "https://qauthn.honeywell.com/as/authorization.oauth2",
  SSO_TOKENENDPOINT: "https://qauthn.honeywell.com/as/token.oauth2",
  DEV_MODENEXUS: false,
};

const LOCALHOST = {
  ENV: "development",
  BASE_URL: "https://nexusdev.honeywell.com",
  SSO_BASE_URL: "https://qauthn.honeywell.com/",
  AUTH_URL: "as/authorization.oauth2?",
  TOKEN_URL: "as/token.oauth2",
  INFO_URL: "idp/userinfo.openid",
  APP_ID: "164",
  CLIENT_ID: "Client_164",
  CLIENT_SECRET: "NEXUSDEV@2022",
  SSO_RESPONSE_TYPE: "code",
  SESS_KEY: "NexusSeSS2DotO__zz",
  SSO_SCOPE: "openid+email+profile",
  SSO_REDIRECT_URL: "/OAuth/Index",
  SSO_LOGOUT_URL: "idp/startSLO.ping?appid=",
  SESS_REDITECT_URI: "RedirectUri",
  API_ENDPOINT: "https://nexus-dev-app-api.azurewebsites.net/", //"https://nexusdev.honeywell.com/",
  //API_ENDPOINT: "https://localhost:7142/", //https://nexus-dev-app-api.azurewebsites.net/
  SSO_AUTHORITY: "https://qauthn.honeywell.com/as/authorization.oauth2",
  SSO_TOKENENDPOINT: "https://qauthn.honeywell.com/as/token.oauth2",
  DEV_MODENEXUS: true,
};

let config = QA_CONFIG;

switch (window.location.hostname) {
  case "nexusqa.honeywell.com":
    config = QA_CONFIG;
    break;
  case "nexus.honeywell.com":
    config = PROD_CONFIG;
    break;
  case "localhost":
    config = LOCALHOST;
    break;
}

export default config;
*/

const APP_CONFIG = {
  ENV: window.ENV.ENV,
  BASE_URL: window.ENV.BASE_URL,
  SSO_BASE_URL: window.ENV.SSO_BASE_URL,
  AUTH_URL: window.ENV.AUTH_URL,
  TOKEN_URL: window.ENV.TOKEN_URL,
  INFO_URL: window.ENV.INFO_URL,
  APP_ID: window.ENV.APP_ID,
  CLIENT_ID: window.ENV.SPA_CLIENT_ID,
  AUTHORITY: window.ENV.SPA_AUTHORITY,
  CLIENT_SECRET: window.ENV.CLIENT_SECRET,
  SSO_AUTHORITY: window.ENV.SSO_AUTHORITY,
  SSO_TOKENENDPOINT: window.ENV.SSO_TOKENENDPOINT,
  SESS_KEY: window.ENV.SESS_KEY,
  SSO_RESPONSE_TYPE: window.ENV.SSO_RESPONSE_TYPE,
  SSO_SCOPE: window.ENV.SSO_SCOPE,
  SSO_REDIRECT_URL: window.ENV.SSO_REDIRECT_URL,
  SSO_LOGOUT_URL: window.ENV.SSO_LOGOUT_URL,
  SESS_REDITECT_URI: window.ENV.SESS_REDITECT_URI,
  API_ENDPOINT: window.ENV.API_ENDPOINT,
  DEV_MODENEXUS: window.ENV.DEV_MODENEXUS,
  DEV_DISPLAY_OPTIONS: window.ENV.HIDE_MVO1_SCOPE === "true",
  SESSION_TIMEOUT_MINS: window.ENV.SESSION_TIMEOUT_MINS,
};

let config = APP_CONFIG;

export default config;
